import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Signal,
  WritableSignal,
  computed,
  signal,
} from "@angular/core";

import { Creative } from "@core/models/creative.types";

import {
  CategoryMenuStructure,
  CategoryOption,
} from "@theme/@confect/components/category-menu/category-menu.component";

@Component({
  selector: "ngx-designs-overview-import",
  templateUrl: "./designs-overview-import.component.html",
  styleUrls: ["./designs-overview-import.component.scss"],
  standalone: false,
})
export class DesignsOverviewImportComponent implements OnInit {
  options: CategoryMenuStructure[];

  designs: WritableSignal<Record<string, Creative[]>> = signal({});
  currentOption: WritableSignal<CategoryOption | null> = signal(null);
  searchString: WritableSignal<string> = signal("");

  currentDesigns: Signal<Creative[]> = computed(() => {
    if (this.currentOption() == null) {
      return [];
    }
    return this.designs()[
      this.currentOption().option + this.currentOption().category
    ].filter((design) =>
      design.name
        .toLocaleLowerCase()
        .includes(this.searchString().toLocaleLowerCase()),
    );
  });

  tableHeader = [
    { name: "", key: "img", size: 1 / 6 },
    { name: "Name", key: "name", size: 3 / 6 },
    { name: "", key: "import", size: 2 / 6 },
  ];

  @Input() set companies(to) {
    if (to == null || to?.length === 0) {
      return;
    }
    this.options = to.map((company, i) => {
      return {
        name: company.company,
        key: company.company_id,
        options: company.accounts.map((account) => account.account),
        collapsed: i !== 0,
      };
    });

    this.currentOption.set({
      category: this.options[0].key,
      option: this.options[0].options[0],
    });

    const designs = {};
    to.forEach((company) => {
      company.accounts.map((account) => {
        designs[account.account + company.company_id] = account.designs;
      });
    });

    this.designs.set(designs);
  }
  @Output() creativeSelected = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  rowClicked(creative) {
    this.creativeSelected.emit(creative);
  }

  setCurrentOption(option: CategoryOption) {
    this.currentOption.set(option);
  }
}
